var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CardComponent"},[_c('div',[_c('v-img',{attrs:{"src":_vm.image,"max-width":"360px","contain":""}})],1),_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }